// extracted by mini-css-extract-plugin
export default {"root":"QLFq4","fadeIn":"IBLX4","fade-in":"R5sbN","text":"lWmMt","message":"Txk9A","button":"piORk","skeleton-progress":"p1j29"};